import { handlePagination, getAPIDataReturn } from "../../../utils/apiFunction";
import { dateFormat, textfieldDateFormat } from "../../../utils/dateFunctions";
import { salesOrderAndShipmentsTypes, statusList } from '../../../utils/constants/selectFields';
import { getOysterGrades, gradeSort } from '../../../definitions/oysters';
import { WAREHOUSESTRINGS } from '../../../utils/constants/warehouse';
const CANCELLED = "Cancelled";
const CANCELED = "Canceled";
const CLOSED = "Closed";
const BACKORDER = "Back Order";
const COMPLETED = "Completed";
const SHIPPING = "Shipping";
const TRANSFERTYPE = 'TR';
const TRANSFERTYPELONG = 'Transfer';
const INVOICED = 'Invoiced';
const CONFIRMED = 'Confirmed';
const OPEN = 'Open';

const getCreditMemoList = async (startDate, endDate, abortController, setLoading, setData) => {
    setLoading(true); 
    const uri = process.env.REACT_APP_BASE_URL;

    const response = await getAPIDataReturn(('/CreditMemo/Get?' + new URLSearchParams({
        startDate: startDate,
        endDate: endDate
    })), abortController);


    var newData = response.map((data) => {
        var nObj = { ...data };
        nObj.effectiveDate = dateFormat(nObj.effectiveDate);
        nObj.name = nObj.customer.name;
        nObj.synced = nObj.synced ? "Yes" : "No";
        nObj.isReused = nObj.isReused ? "Yes" : "No";

        return nObj;
    })


    setData(newData);
    setLoading(false);
}

export default getCreditMemoList;